// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VBannerText = createSimpleFunctional('v-banner-text');
//# sourceMappingURL=VBannerText.mjs.map